import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class BiddingInfoDetailsV2Api extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'bidding-info-details-v2'
  }

}